/* eslint-disable react/no-danger */
import React, { useRef } from "react";
import { useIntl } from "gatsby-plugin-intl";
import PageSection from "components/PageSection";
import FindBranchForm from "containers/FindBranchForm";
import mapAnimation from "images/map.mp4";
import "./branches.scss";

const Branches = () => {
  const { formatMessage } = useIntl();

  const branchesRef = useRef(null);

  return (
    <PageSection
      ref={branchesRef}
      className="pt-48 pb-20"
      id="branches"
      startIconTo="branches"
      startIconClassName="mt-20"
      startScrollIcon
    >
      <div className="container">
        <div className="flex flex-wrap">
          <div className="w-full lg:w-7/12 order-2 lg:order-1">
            <h1
              className="text-black text-4xl mb-6 leading-normal"
              dangerouslySetInnerHTML={{
                __html: formatMessage({ id: "branches.title" }),
              }}
            />
            <p
              className="text-2xl w-11/12 text-justify"
              dangerouslySetInnerHTML={{
                __html: formatMessage({ id: "branches.text" }),
              }}
            />

            <FindBranchForm className="mt-16 w-full lg:w-10/12" />
          </div>

          <div className="w-full sm:w-8/12 lg:w-5/12 order-1 lg:order-2 mx-auto lg:mx-0 ltr:ml-auto rtl:mr-auto mb-24 lg:mb-0">
            <video
              className="w-full"
              controls={false}
              autoPlay
              playsInline
              loop
              muted
            >
              <source src={mapAnimation} type="video/mp4" />
            </video>
          </div>
        </div>
      </div>
    </PageSection>
  );
};

export default Branches;
